import { render, staticRenderFns } from "./work-place.vue?vue&type=template&id=ee9b3ff8&scoped=true"
import script from "./work-place.vue?vue&type=script&lang=js"
export * from "./work-place.vue?vue&type=script&lang=js"
import style0 from "./work-place.vue?vue&type=style&index=0&id=ee9b3ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9b3ff8",
  null
  
)

export default component.exports